export default class User {

    userId
    clientId
    username
    typ
    email
    contactName
    language

    static fromObject(o) {
        if (typeof o['userId'] !== 'number' || parseInt(o['userId']) < 0) {
            throw new Error('Invalid field userId for User.')
        }
        if (typeof o['clientId'] !== 'number' || parseInt(o['clientId']) < 0) {
            throw new Error('Invalid field clientId for User.')
        }
        if (typeof o['username'] !== 'string' || o['username'] === '') {
            throw new Error('Invalid field username for User.')
        }
        if (typeof o['typ'] !== 'string' || ['user', 'admin'].indexOf(o['typ']) === -1) {
            throw new Error('Invalid field typ for User.')
        }
        if (typeof o['email'] !== 'string' || o['email'] === '') {
            throw new Error('Invalid field email for User.')
        }
        if (typeof o['contactName'] !== 'string') {
            throw new Error('Invalid field contactName for User.')
        }
        if (typeof o['language'] !== 'string' || ['de', 'en'].indexOf(o['language'].toLowerCase()) === -1) {
            throw new Error('Invalid field language for User.')
        }

        const u = new User()
        u.userId = parseInt(o['userId'])
        u.clientId = parseInt(o['clientId'])
        u.username = o['username'].trim()
        u.typ = o['typ'].trim()
        u.email = o['email'].trim()
        u.contactName = o['contactName']
        u.language = o['language'].toLowerCase()
        return u
    }

}